import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c9ffc866"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9ffc866')) {
      api.createRecord('c9ffc866', component.options)
    } else {
      api.reload('c9ffc866', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c9ffc866", function () {
      api.rerender('c9ffc866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabFullScreen/index.vue"
export default component.exports